import { IconMap, IconPath } from '@shared/common/icons';

export class IconsDefinitionHelper {
  icons = IconMap;
}
